import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import ConstraintForm from './ConstraintForm';
import { snakeCaseToTitleCase } from '../../../../common/utils/api_utils';
import CustomLoader from '../../../common/CustomLoader';
import showAlert from '../../../../common/utils/alert';
import { deleteField } from '../../../../features/collections/redux/deleteField';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { description } from '../../../../common/utils/event_constants';
export default class ConstraintDetail extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    showConstraintValue: PropTypes.func.isRequired,
    constraint: PropTypes.object.isRequired,
  };

  state = {
    isEditConstraint: false,
  };

  enableUpdateConstraint = () => {
    this.setState({ isEditConstraint: true });
  };

  disableUpdateConstraint = () => {
    this.setState({ isEditConstraint: false });
  };

  updateConstraint = (updatedConstraintObj) => {
    const { projectId, collection, constraint, version, actions, commonActions } = this.props;
    updatedConstraintObj.uuid = constraint.uuid;
    const finalConstraintObj = {
      projectId,
      collectionUuid: collection.uuid,
      constraintUuid: constraint.uuid,
      data: updatedConstraintObj,
      version,
    };
    actions.updateConstraintOfCollection(finalConstraintObj);
    commonActions.trackCollectionChange({ uuid: collection.uuid, name: collection.collectionName });
    this.disableUpdateConstraint();
  };

  handleDelete = () => {
    const { projectId, collection, constraint, version, actions, commonActions } = this.props;
    const preConfirm = () => {
      actions.deleteCollectionConstraint({
        projectId,
        version,
        collectionUuid: collection.uuid,
        constraintId: constraint.uuid,
      });
      commonActions.trackCollectionChange({
        uuid: collection.uuid,
        name: collection.collectionName,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  showEditConstraint = () => {
    const {
      constraint,
      collection,
      showConstraintValue,
      showDerivedConstraintLoader,
      showConstraintDeleteLoader,
      deleteFlag,
    } = this.props;
    const { isEditConstraint } = this.state;
    if (isEditConstraint) {
      return (
        <div className="col-12">
          <ConstraintForm
            constraintType={constraint.constraintType}
            constraint={constraint}
            handleSubmit={this.updateConstraint}
            showDerivedConstraintLoader={showDerivedConstraintLoader}
            collection={collection}
            isCollection={true}
          />
        </div>
      );
    } else {
      return (
        <Fragment>
          <div className="col-12">
            <div className="pt-1">
              <b>Name: </b> {constraint.name}
            </div>

            <div className="pt-1">
              <b>Type: </b> {snakeCaseToTitleCase(constraint.constraintType)}
            </div>

            <div className="pt-1">
              <b>Fields: </b> {showConstraintValue(constraint.constraintType, constraint.fields)}
            </div>
          </div>
          <div className="col-12 text-right pb-2">
            <button
              type="button"
              className="btn btn-sm btn-theme-delete mr-1"
              disabled={showConstraintDeleteLoader}
              style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
              onClick={deleteFlag ? this.handleDelete : undefined}
            >
              <i className="wb webconnect-trash-regular"></i> Delete
              {deleteFlag ? null : (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
              <CustomLoader loading={showConstraintDeleteLoader} />
            </button>
            <button
              type="button"
              className="btn btn-sm btn-theme-submit mr-1"
              disabled={showDerivedConstraintLoader}
              onClick={this.enableUpdateConstraint}
            >
              <i className="wb webconnect-pencil"></i> Edit
            </button>
          </div>
        </Fragment>
      );
    }
  };

  render() {
    return <div className="row pt-2">{this.showEditConstraint()}</div>;
  }
}
